import ShareSocialNetworkButton from './ShareSocialNetworkButton';

export default ShareSocialNetworkButton;
